import { Flex, Tabs, TabList, Tab, Box } from '@chakra-ui/react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';

function HomeLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const activeIndex = location.pathname === '/studio' ? 1 : 0;

  return (
    <Flex
      direction="column"
      flex="1"
      bgGradient="linear(to-b, #3a4190, #646AB0)"
    >
      <Flex justifyContent="center" pt={5} px={4}>
        <Tabs
          index={activeIndex}
          onChange={(i) => navigate(i === 0 ? '/' : '/studio')}
          isFitted
          width="100%"
          maxW="sm"
          variant="soft-rounded"
        >
          <TabList
            bg="whiteAlpha.200"
            borderRadius="full"
            p={1}
          >
            <Tab
              color="whiteAlpha.700"
              fontSize="sm"
              fontWeight="medium"
              borderRadius="full"
              _selected={{ color: "#3a4190", bg: "white", fontWeight: "bold" }}
            >
              DodoDot Official
            </Tab>
            <Tab
              color="whiteAlpha.700"
              fontSize="sm"
              fontWeight="medium"
              borderRadius="full"
              _selected={{ color: "#3a4190", bg: "white", fontWeight: "bold" }}
            >
              DodoDot Studio
            </Tab>
          </TabList>
        </Tabs>
      </Flex>
      <Outlet />
    </Flex>
  );
}

export default HomeLayout;
